/**
 * Time unit abbreviations
 */
enum TimeUnit {
	MILLISECOND = 'ms',
	SECOND = 's',
	MINUTE = 'min',
	HOUR = 'h',
	DAY = 'd',
	MONTH = 'm',
	YEAR = 'y'
}

export default TimeUnit;